$(function(){
	$('.menu-toggle, .body-overlay').on('click', function(){
		$('header nav, .body-overlay').toggleClass('open');
	});

	$('.menu-item-has-children > span').on('click', function(){
		$(this).next('ul').slideToggle();
	});
});

$(window).load(function(){

	function getScroll() {
		var b = document.body;
		var e = document.documentElement;
		return {
			left: parseFloat( window.pageXOffset || b.scrollLeft || e.scrollLeft ),
			top: parseFloat( window.pageYOffset || b.scrollTop || e.scrollTop )
		};
	}
	var myHeader = $('header nav');
	myHeader.data( 'position', myHeader.position() );

	setTimeout(() => {
		$(window).scroll(function() {
			var hPos = myHeader.data('position'), scroll = getScroll();
			if ( hPos.top < scroll.top ){
				$('.sticky-nav').addClass('fixed');

				var navHeight = $('.sticky-nav').height();
				$('main').css({
					'marginTop' : navHeight
				});
			}
			else {
				$('.sticky-nav').removeClass('fixed');
				$('main').css({
					'marginTop' : 0
				});
			}
		});
	}, 200);


	$(window).resize(function() {
		myHeader.data( 'position', myHeader.position() );
		var hPos = myHeader.data('position'), scroll = getScroll();
		if ( hPos.top < scroll.top ){
			$('.sticky-nav').addClass('fixed');

			var navHeight = $('.sticky-nav').height();
			$('main').css({
				'marginTop' : navHeight
			});
		}
		else {
			$('.sticky-nav').removeClass('fixed');
			$('main').css({
				'marginTop' : 0
			});
		}

	});
});
